import React, { Component } from "react";
import * as s from "./Checkbox.module.scss";

export interface CheckboxProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  type: "check" | "line";
  selected?: boolean;
  disabled?: boolean;
  onChange?: (boolean) => void;
}

export class Checkbox extends Component<CheckboxProps> {
  onChange = () => {
    const { selected, onChange } = this.props;
    if (onChange) {
      onChange(!selected);
    }
  };

  render() {
    const { selected, disabled, type, className, children } = this.props;

    const classes = [s.checkboxContainer];

    if (disabled) classes.push(s.disabled);

    if (className) classes.push(className);

    return (
      <label className={classes.join(" ")}>
        <input
          disabled={!!disabled}
          type="checkbox"
          checked={selected}
          onChange={this.onChange}
        />
        <span data-type={type} />
        {children}
      </label>
    );
  }
}
